{
  "enum": {
    "ExcIncreaseV1AccountNumberStatus": {
      "ACTIVE": "Active",
      "DISABLED": "Disabled",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIncreaseV1AchStatus": {
      "POSTED": "Posted",
      "REJECTED": "Rejected",
      "RETURNED": "Returned",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIncreaseV1WireStatus": {
      "POSTED": "Posted",
      "REJECTED": "Rejected",
      "REVERSED": "Reversed",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcIncreaseV1AccountNumberQueryServiceAccountNumberListFilterableFields": {
      "accountNumberId": "Account Number ID",
      "data": {
        "increaseId": "Increase ID",
        "spec": {
          "accountId": "Account",
          "programId": "Program"
        }
      },
      "status": "Status"
    },
    "ExcIncreaseV1AchQueryServiceAchListFilterableFields": {
      "achId": "ACH",
      "data": {
        "increaseId": "Increase ID",
        "spec": {
          "accountId": "Account",
          "programId": "Program",
          "sourceId": "Source",
          "transferId": "Transfer"
        }
      },
      "status": "Status"
    },
    "ExcIncreaseV1WireQueryServiceWireListFilterableFields": {
      "data": {
        "increaseId": "Increase ID",
        "spec": {
          "accountId": "Account",
          "programId": "Program",
          "sourceId": "Source",
          "transferId": "Transfer"
        }
      },
      "status": "Status",
      "wireId": "Wire"
    }
  },
  "oneOf": {
    "ExcIncreaseV1AccountNumberEventType": {
      "created": "Created",
      "disabled": "Disabled",
      "reenabled": "Re-Enabled",
      "requested": "Requested"
    },
    "ExcIncreaseV1AchEventType": {
      "accepted": "Accepted",
      "noC": "No C",
      "posted": "Posted",
      "rejected": "Rejected",
      "returned": "Returned",
      "settled": "Settled",
      "submitted": "Submitted"
    },
    "ExcIncreaseV1WireEventType": {
      "accepted": "Accepted",
      "posted": "Posted",
      "rejected": "Rejected",
      "reversed": "Reversed",
      "settled": "Settled",
      "submitted": "Submitted"
    }
  },
  "searchEnum": {
    "ExcIncreaseV1AchQueryServiceAchListSearchableFields": {
      "data": {
        "spec": {
          "bankDetails": {
            "accountNumber": "Data Spec Bank Details Account Number"
          }
        }
      }
    },
    "ExcIncreaseV1WireQueryServiceWireListSearchableFields": {
      "data": {
        "spec": {
          "bankDetails": {
            "accountNumber": "Data Spec Bank Details Account Number"
          }
        }
      }
    }
  },
  "sortEnum": {
    "ExcIncreaseV1AccountNumberQueryServiceAccountNumberListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcIncreaseV1AchQueryServiceAchListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "ExcIncreaseV1WireQueryServiceWireListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}